import { createConfirmation } from "react-confirm";
import AddUserDialog from "./AddUserDialog";

export const showAddUserDialog = createConfirmation(AddUserDialog);
